__turbopack_context__.v({
  "footer_wrapper": "index-module-scss-module__EjF6xq__footer_wrapper",
  "main": "index-module-scss-module__EjF6xq__main",
});
